import { Language } from "@/hooks/use-browser-language";

export const socialSellingThankYouTranslations = {
  pl: {
    // Hero Section
    heroTitle: "Dziękujemy za zgłoszenie!",
    heroSubtitle: "Nasz zespół analizuje Twoje dane",
    heroDescription: "Raport z audytem Social Selling otrzymasz na email w ciągu",
    heroTimeframe: "24-48 godzin",

    // Hero Stats
    stat1Value: "78%",
    stat1Label: "Sprzedawców używających social selling osiąga lepsze wyniki",
    stat2Value: "51%",
    stat2Label: "Większa szansa na osiągnięcie quotę sprzedażowej",
    stat3Value: "45%",
    stat3Label: "Więcej okazji sprzedażowych",
    stat4Value: "5.3x",
    stat4Label: "Więcej potencjalnych klientów miesięcznie",

    // Detailed Results Section
    resultsTitle: "Co firmy osiągają dzięki Social Selling",
    resultsSubtitle: "Dane z tysięcy kampanii B2B pokazują realne korzyści LinkedIn",

    // Result Card 1: Social Selling & Prospecting
    result1Title: "Social Selling & Prospecting",
    result1MainStat: "78% sprzedawców używających social selling osiąga lepsze wyniki niż ci, którzy tego nie robią",
    result1Bullet1: "51% większe szanse na osiągnięcie quotę sprzedażowej",
    result1Bullet2: "45% więcej okazji sprzedażowych",
    result1Bullet3: "Średnio 5.3x więcej potencjalnych klientów miesięcznie",

    // Result Card 2: Personal Branding
    result2Title: "Personal Branding",
    result2MainStat: "Pracownicy z personal branding generują 5x więcej leadów dla firmy",
    result2Bullet1: "Zespoły z aktywnymi profilami osiągają o 31% wyższe wyniki sprzedażowe",
    result2Bullet2: "Firmy z ekspertami na LinkedIn budują zaufanie 3x szybciej",
    result2Bullet3: "Posty pracowników mają 8x wyższy engagement niż strona firmowa",

    // Result Card 3: Lead Generation
    result3Title: "Lead Generation",
    result3MainStat: "46% całego social media traffic B2B pochodzi z LinkedIn",
    result3Bullet1: "2x więcej leadów przy regularnym publikowaniu wartościowych treści",
    result3Bullet2: "92% konsumentów ufa ludziom, nie markom",
    result3Bullet3: "60% kupuje od marek dzięki personal reputation pracowników",

    // Next Steps Section
    nextStepsTitle: "Co dalej?",
    nextStepsSubtitle: "Twoje kolejne kroki do sukcesu na LinkedIn",
    nextStep1Title: "Sprawdź swoją skrzynkę email (24-48h)",
    nextStep1Desc: "Nasz zespół przygotuje dla Ciebie szczegółowy audyt i wyśle go na podany adres",
    nextStep2Title: "Zarezerwuj bezpłatną konsultację",
    nextStep2Desc: "Omówimy wyniki audytu i podpowiemy kolejne kroki",
    nextStep3Title: "Rozpocznij wdrażanie Quick Wins",
    nextStep3Desc: "Zobacz pierwsze efekty już za kilka tygodni",

    // CTA Section
    ctaTitle: "Gotowy na kolejny krok?",
    ctaSubtitle: "Wróć do strony głównej lub skontaktuj się z nami, aby omówić Twoje wyniki",
    ctaButton: "Strona główna",

    // Sources
    sources: "Źródła: LinkedIn Sales Solutions, Sopro.io, Sprout Social, 2024-2025",
  },
  en: {
    // Hero Section
    heroTitle: "Thank you for your submission!",
    heroSubtitle: "Our team is analyzing your data",
    heroDescription: "You will receive the Social Selling audit report via email within",
    heroTimeframe: "24-48 hours",

    // Hero Stats
    stat1Value: "78%",
    stat1Label: "Of salespeople using social selling achieve better results",
    stat2Value: "51%",
    stat2Label: "Higher chance of meeting sales quota",
    stat3Value: "45%",
    stat3Label: "More sales opportunities",
    stat4Value: "5.3x",
    stat4Label: "More potential customers monthly",

    // Detailed Results Section
    resultsTitle: "What companies achieve with Social Selling",
    resultsSubtitle: "Data from thousands of B2B campaigns shows real LinkedIn benefits",

    // Result Card 1: Social Selling & Prospecting
    result1Title: "Social Selling & Prospecting",
    result1MainStat: "78% of salespeople using social selling outperform those who don't",
    result1Bullet1: "51% higher chance of meeting sales quota",
    result1Bullet2: "45% more sales opportunities",
    result1Bullet3: "Average of 5.3x more potential customers monthly",

    // Result Card 2: Personal Branding
    result2Title: "Personal Branding",
    result2MainStat: "Employees with personal branding generate 5x more leads for the company",
    result2Bullet1: "Teams with active profiles achieve 31% higher sales results",
    result2Bullet2: "Companies with LinkedIn experts build trust 3x faster",
    result2Bullet3: "Employee posts get 8x higher engagement than company pages",

    // Result Card 3: Lead Generation
    result3Title: "Lead Generation",
    result3MainStat: "46% of all B2B social media traffic comes from LinkedIn",
    result3Bullet1: "2x more leads with regular valuable content publishing",
    result3Bullet2: "92% of consumers trust people, not brands",
    result3Bullet3: "60% buy from brands thanks to employee personal reputation",

    // Next Steps Section
    nextStepsTitle: "What's next?",
    nextStepsSubtitle: "Your next steps to LinkedIn success",
    nextStep1Title: "Check your email inbox (24-48h)",
    nextStep1Desc: "Our team will prepare a detailed audit and send it to your email address",
    nextStep2Title: "Book a free consultation",
    nextStep2Desc: "We'll discuss the audit results and suggest next steps",
    nextStep3Title: "Start implementing Quick Wins",
    nextStep3Desc: "See first results in just a few weeks",

    // CTA Section
    ctaTitle: "Ready for the next step?",
    ctaSubtitle: "Return to the homepage or contact us to discuss your results",
    ctaButton: "Homepage",

    // Sources
    sources: "Sources: LinkedIn Sales Solutions, Sopro.io, Sprout Social, 2024-2025",
  }
};

export type ThankYouTranslationKey = keyof typeof socialSellingThankYouTranslations.pl;

export function getThankYouTranslation(lang: Language, key: ThankYouTranslationKey): string {
  return socialSellingThankYouTranslations[lang][key] || socialSellingThankYouTranslations.en[key];
}
